import { callApi } from './api';

export type ApprovalStatus = {
  approval_status: 'approved' | 'unapproved';
};

export const updateAttendanceReservationApproval = async (
  reservationID: number,
  input: ApprovalStatus
) => {
  const { status, result } = await callApi<boolean>(
    `attendance-reservations/${reservationID}`,
    'PATCH',
    undefined,
    input,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
